import {
  Grid,
  Box,
  Button,
  TablePagination,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Card,
  CardContent,
  Alert,
} from '@material-ui/core';

import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { checkAutoLogin } from 'src/actions/getTokenActions';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import Moment from 'react-moment';
import moment from 'moment';

const ItemDetails = React.memo(({
  detailDate, deviceid, devicename, From, To, Compression, Datacenter, Rack, Circiut, Phase, IsAcceptInterpolate, closedetail, ...rest
}) => {

  const dispatch = useDispatch()
  const navigate = useNavigate();
  const isLogin = useSelector(state => state.gettocken.islogin);
  const [limit, setLimit] = useState(25);
  const [page, setPage] = useState(0);
  const [detaildata, setdetaildata] = useState([]);
  const [detailcount, setdetailcount] = useState(0);
  const [totaldevice, settotaldevice] = useState(0);
  const [progress, setprogress] = useState(false);
  const myRef = useRef(null)


  console.log("detailDate", detailDate)
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
  };

  useEffect(() => {
    const apiurl = sessionStorage.getItem('apiurl')
    console.log("Apiurl", apiurl)
    setprogress(true)
    let token = checkAutoLogin(dispatch)
    if (!token && isLogin === false) {
      navigate('/login', { replace: true });
    } else {
      axios.get(`https://${apiurl}/api/Values/GetByDeviceIdWithCopmrassion/?DeviceId=${deviceid}&PageNumber=${page + 1}&pageSize=${limit}&From=${From}&To=${To}&Compression=${Compression}&DataCenterId=${Datacenter}&RackId=${Rack}&CircuitId=${Circiut}&PhaseId=${Phase}&IsAcceptInterpolate=${IsAcceptInterpolate}&DetailDate=${detailDate}`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token,
        }
      }).then(res => {
        console.log('Detail: ', res)
        setdetaildata(res.data.logs)
        setdetailcount(res.data.totalCount);
        settotaldevice(res.data.totalSumme.toFixed(2))
        setprogress(false)

      })
    }
  }, [page, limit, From, To, Compression, Datacenter, Rack, Circiut, Phase, IsAcceptInterpolate, isLogin])

  return (
    <>
    {console.log("RERENDER !!!!")}
      <Box sx={{ paddingTop: 2 }}>
        <Card style={{ backgroundColor: '#f3f3f3' }}>
          <CardContent>
            <Grid container spacing={2}  >
              <Grid item xs={5} md={5}><Typography variant="h4">{devicename}</Typography><br />         
              </Grid>
              <Grid item xs={5} md={5}><Typography variant="h2">{totaldevice} {Compression === "none" ? "kW" : "kWh"}</Typography> </Grid>
              <Grid item xs={2} md={2}><Button fullWidth variant="contained" onClick={() => closedetail()}>Schliessen</Button></Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>
      {/* {progress &&
            <LinearProgress />
        } */}
      <Card style={{ backgroundColor: '#f3f3f3' }}>
        <CardContent>
          <Table stickyHeader>
            <TableHead ref={myRef} style={{ backgroundColor: '#f3f3f3' }}>
              <TableRow style={{ backgroundColor: '#f3f3f3' }}>
                <TableCell style={{ backgroundColor: '#f3f3f3' }}>
                  Datum
                </TableCell>
                <TableCell style={{ backgroundColor: '#f3f3f3' }}>
                  Stromkreis
                </TableCell>
                <TableCell style={{ textAlign: 'center', backgroundColor: '#f3f3f3' }}>
                  Phase
                </TableCell>
                <TableCell style={{ textAlign: 'center', backgroundColor: '#f3f3f3' }}>
                {Compression === "none" ? "kW" : "kWh"}
                </TableCell>
                <TableCell style={{ textAlign: 'center', backgroundColor: '#f3f3f3' }}>
                  Gemessen
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {detaildata.length === 0 && progress === false &&
                <TableRow>
                  <TableCell colSpan="5">
                    <Alert severity="error">Für die ausgewählten Einstellungen sind keine Daten verfügbar</Alert>
                  </TableCell>
                </TableRow>
              }

        {detaildata.length === 0 && progress === true &&
                <TableRow>
                  <TableCell colSpan="5">
                  
            <LinearProgress />
          
                  </TableCell>
                </TableRow>
              }

              {detaildata.map((item, index) => (
                <TableRow
                  hover
                  key={index + 111}
                ><TableCell>
                    {Compression === "none" &&
                      <span>{item.date}</span>
                    }
                    {Compression === "day" &&
                      // <span>{item.date}</span>
                      <span>{moment(item.date, "DD.MM.YYYY").format("DD.MM.YYYY")}</span>
                    }
                    {Compression === "month" &&
                    <span>{moment(item.date, "MM.YYYY").format("MMMM YYYY")}</span>
                    }
                    {Compression === "year" &&
                      <Moment format="YYYY">{item.date}</Moment>
                    }
                  </TableCell>
                  <TableCell>
                    {item.phase.circuit.name}
                  </TableCell>
                  <TableCell style={{ textAlign: 'center' }}>
                    {item.phase.name}
                  </TableCell>
                  <TableCell style={{ textAlign: 'center' }}>
                    {item.value.toFixed(2)}  {Compression === "none" ? "kW" : "kWh"}
                  </TableCell>
                  <TableCell style={{ textAlign: 'center' }}>
                    {item.logType.name}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={detailcount}
            rowsPerPage={limit}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </CardContent>
      </Card>
    </>
  );
});

export default ItemDetails;
